var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kr-brand-icon", class: _vm.dynamicClasses },
    [
      !_vm.methodIconContent
        ? [_c("span", { staticClass: "kr-placeholder" })]
        : [
            _c("SvgImage", {
              attrs: {
                title: _vm.title,
                decorative: false,
                template: _vm.methodIconContent,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }